import React from 'react';
import MyMapComponent from './MyMapComponent';

const MapAndContactSection = () => {
  return (
    <section className="map-contact-section">
      <h1 сlassName="map-title">Наше местоположение</h1>
      <h3 className='map_desc'c>На карте вы можете увидеть точное расположение нашего гостевого дома. Также мы предлагаем удобные способы связи через мессенджеры.</h3>
      <div className="map-contact-container">
      <div className="map-container">
        <MyMapComponent />
      </div>
      <div className="contact-info">
        <h2>Контакты</h2>
        <p>Адрес: г. Керчь, ул. 23-го Мая д. 180 / ул Рыбакова,2а</p>
        <p>Телефон: +7 (978) 011-60-61</p>
        <p>Email: natalia.kachurina@mail.ru</p>
        <p>Часы работы: 9:00 - 22:00</p>
        <div className="social-buttons">
      <a 
        href="https://t.me/GostevojDomEdelweisKerch" 
        target="_blank" 
        rel="noopener noreferrer" 
        className='telegram-link'
      >
        <img 
          src="./img/telegram.png" 
          alt="Telegram" 
          width="32" 
          height="32" 
          className='telegram-icon'
        />
      </a>

      <a 
        href="https://wa.me/qr/ZH5EL4M5ZPTJE1" 
        target="_blank" 
        rel="noopener noreferrer" 
        className='whatsapp-link'
      >
        <img 
          src="./img/whatsapp.png" 
          alt="WhatsApp" 
          width="32" 
          height="32" 
          className='whatsapp-icon'
        />
      </a>
    </div>
      </div>
      </div>
    </section>
  );
};

export default MapAndContactSection;